import React from "react";
import Features from "@/components/Dashboard/HelpDesk/Features";
import TicketsStatus from "@/components/Dashboard/HelpDesk/TicketsStatus";
import SupportStatus from "@/components/Dashboard/HelpDesk/SupportStatus";
import Activity from "@/components/Dashboard/HelpDesk/Activity";

import { checkIsNotLogged } from "@/utils/authCheck";
import { getUserData } from "@/utils/userData";
import { fetchWrapper } from "../helpers";

import { useState, useEffect } from "react";
import { Avatar, Box, Button, Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import CircularProgress from "@mui/material/CircularProgress";

import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/Email";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import Description from "@mui/icons-material/Description"; 
import { List, ListItemButton, ListItemIcon, ListItemText, IconButton } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import NotificationSheet from "@/components/NotificationSheet";
import DeleteAccountSheet from "@/components/mobileSheets/DeleteAccount";
import ChangePasswordSheet from "@/components/mobileSheets/ChangePassword";
import ChangeEmailSheet from "@/components/mobileSheets/ChangeEmail";
import ChangePersonalDetailsSheet from "@/components/mobileSheets/ChangePersonalDetailsSheet";
import ChangeSettingsSheet from "@/components/mobileSheets/ChangeSettingsSheet";

import SupportTable from "@/components/SupportTable";
import FoldersTable from "@/components/FoldersTable"; 

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { useRouter } from "next/router";

const Input = styled("input")({
	display: "none",
});

// Toast Notification
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CookieRounded, LockOutlinedIcon } from "@mui/icons-material";

export default function HelpDesk() {
	checkIsNotLogged("/autentificare");

	const router = useRouter();

	const { userData } = getUserData();

	// PWA Vars
	const [isOpen, setIsOpen] = useState(false);
	const [isOpenDelete, setIsOpenDelete] = useState(false);
	const [isOpenPassword, setIsOpenPassword] = useState(false);
	const [isOpenEmail, setIsOpenEmail] = useState(false);
	const [isOpenDetails, setIsOpenDetails] = useState(false);
	const [isOpenSettings, setIsOpenSettings] = useState(false);

	const [isUploading, setIsUploading] = useState(false);

	const [notificationTitle, setNotificationTitle] = useState("");
	const [notificationMessage, setNotificationMessage] = useState("");

	const [openDoc, setOpenDoc] = useState(null);
	const [visible, setVisible] = useState(false);

	const [avatar, setAvatar] = useState("");

	const [adminStats, setAdminStats] = useState([]);

	const fetchAdminStats = async () => {
          try {
               if(userData?.admin > 0) {
                    const response = await fetchWrapper.get("/api/admin/stats");
                    setAdminStats(response);
               }
          } catch (error) {
               console.error("Eroare la obținerea statisticilor admin:", error);
               return; 
          }
     };

	useEffect(() => {
		if (userData && userData.avatar) {
			setAvatar(userData.avatar);
		}

          fetchAdminStats(); 
	}, [userData]);

     const handleAvatarChange = async (e) => {
		const file = e.target.files[0];
		if (!file) return;

		try {
			const formData = new FormData();
			formData.append("file", file);

			const response = await fetchWrapper.post("/api/users/mobile/avatar-upload", formData, true);

			if (response) {
				setAvatar(response.url);
				setNotificationTitle("Profil actualizat.");
				setNotificationMessage("Poza de profil a fost actualizata.");
                    setIsOpen(true); 
			} else {
				toast.error("Eroare la procesarea avatarului.");
			}
		} catch (err) {
			console.error("Eroare:", err);
			toast.error("Eroare la încărcare.");
		} 
	};

	const handleSignatureUpload = async (e) => {
		const file = e.target.files[0];
		if (!file) return;

		setIsUploading(true);

		try {
			const formData = new FormData();
			formData.append("file", file);

			const response = await fetchWrapper.post("/api/users/mobile/signature-upload", formData, true);

			if (response) {
				setNotificationTitle("Semnătura procesată");
				setNotificationMessage("Semnătura dumneavoastră a fost procesată cu succes.");
				setIsOpen(true);
				userData.signatureID = response.signatureID;
			} else {
				toast.error("Eroare la procesarea semnăturii.");
			}
		} catch (err) {
			console.error("Eroare:", err);
			toast.error("Eroare la încărcare.");
		} finally {
			setIsUploading(false);
		}
	};

	const handleViewSignature = async (signatureID) => {
		try {
			const params = new URLSearchParams({ signatureID });
			const response = await fetchWrapper.get(`/api/users/mobile/signature-upload?${params}`);

			if (response) {
				setOpenDoc(response.filePath);
				setIsOpen(true);
			} else {
				toast.error("Eroare la procesarea semnăturii.");
			}
		} catch (err) {
			console.error("Eroare:", err);
			toast.error("Eroare la încărcare.");
		}
	};

	if (userData && userData?.colaborator) {
		return (
			<>
				<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
					<Grid item xs={12} md={12} lg={12} xl={12}>
						<TicketsStatus />
					</Grid>
				</Grid>
			</>
		);
	}

	if (userData && userData?.admin > 0) {
		return (
			<>
			    <Box sx={{ mt: 3, mb: 3 }}>
					<Button
						variant='outlined'
						color='primary'
						fullWidth
						endIcon={<ArrowForwardIosIcon />}
						sx={{
							borderRadius: "10px",
							py: 1.3,
							fontSize: "0.95rem",
							fontWeight: 500,
							textTransform: "none",
							borderWidth: "1.5px",
							transition: "all 0.25s ease",
							"&:hover": {
								borderColor: "#1565c0",
								backgroundColor: "rgba(21, 101, 192, 0.04)",
								transform: "translateY(-1px)",
							},
						}}
						onClick={() => router.push('/admin/my-stats')}>
						Vezi istoricul clienților cu care ai lucrat pe ultimele 2 luni
					</Button>
				</Box>
				
				{/* Features */}
				<Features adminStats={adminStats} />

				<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
					<Grid item xs={12} md={12} lg={12} xl={12}>
						{/* TicketsStatus */}
						<TicketsStatus />
					</Grid>
				</Grid>

				<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
					{/* Rândul cu două coloane: stânga și dreapta */}
					<Grid item xs={12} md={12} lg={12} xl={12}>
						<Grid container columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
							{/* Coloana stângă */}
							<Grid item xs={12} md={6}>
								<SupportTable columns={["Subiect", "Client", "Status"]} opened={true} />
							</Grid>

							{/* Coloana dreaptă */}
							<Grid item xs={12} md={6}>
								<div style={{ height: "100%" }}>
									<FoldersTable columns={["Dosar", "Client", "Status"]} opened={true} />
								</div>
							</Grid>
						</Grid>
					</Grid>

					{/* Rând separat pentru Activity (pe toată lățimea) */}
					<Grid item xs={12}>
						<Activity />
					</Grid>
				</Grid>
			</>
		);
	} else if (userData && userData.admin == 0) {
		const handleDeleteAccount = async () => {
			const resp = await fetchWrapper.delete("/api/users/mobile/account");

			if (resp.success) {
				setIsOpenDelete(false);
				handleLogout();
			} else {
				toast.error("Oops! Ceva nu a functionat bine, va rugam sa incercati din nou mai tarziu.");
				return;
			}
		};

		const items = [
			{
				label: "Modificare detalii personale",
				icon: <PersonIcon />,
				onClickEvent: () => setIsOpenDetails(true),
			},
			{ label: "Modificare email", icon: <EmailIcon />, onClickEvent: () => setIsOpenEmail(true) },
			{ label: "Modificare parola", icon: <LockIcon />, onClickEvent: () => setIsOpenPassword(true) },
			{ label: "Notificări", icon: <NotificationsIcon />, onClickEvent: () => router.push("/notificari") },
			{
				label: "Setări de confidențialitate & aplicație",
				icon: <SettingsIcon />,
				onClickEvent: () => setIsOpenSettings(true),
			},
               {
				label: "Termeni & condiții",
				icon: <Description />,
				onClickEvent: () => router.push('/termeni-si-conditii'),
			},
               {
				label: "Politică de confidentialitate",
				icon: <Description />,
				onClickEvent: () => router.push('/politica-de-confidentialitate'),
			},
               {
				label: "Politica Cookies",
				icon: <CookieRounded/>,
				onClickEvent: () => router.push('/politica-cookies'),
			},
			{
				label: "Ștergeți contul",
				icon: <DeleteIcon />,
				color: "error",
				onClickEvent: () => setIsOpenDelete(true),
			},
		];

		return (
			<>
				<Box sx={{ maxWidth: 600, mx: "auto", mt: 5 }}>
					<center>
						<Avatar
							src={avatar}
							sx={{
								width: 100,
								height: 100,
								mx: "auto",
								mb: 2,
							}}
						/>
						<label htmlFor='avatar-upload'>
							<Input
								accept='image/*'
								id='avatar-upload'
								type='file'
								onChange={handleAvatarChange}
								sx={{ display: "none" }}
							/>
							<Button variant='outlined' component='span' size='small'>
								<i
									className='ri-image-line'
									style={{
										marginRight: 5,
									}}></i>{" "}
								Actualizează avatar
							</Button>
						</label>
					</center>
					<List sx={{ display: "flex", flexDirection: "column", gap: 1, marginTop: 2 }}>
						{items.map(({ label, icon, color, onClickEvent }) => (
							<ListItemButton
								key={label}
								sx={{
									border: "1px solid #ccc",
									borderRadius: 2,
									paddingRight: 2,
									paddingLeft: 1.5,
								}}
								onClick={onClickEvent || (() => {})}>
								<ListItemIcon sx={{ color: color ? `${color}.main` : "inherit", minWidth: 36 }}>
									{icon}
								</ListItemIcon>

								<ListItemText primary={label} />

								<ChevronRightIcon sx={{ color: "#aaa" }} />
							</ListItemButton>
						))}
					</List>

					<Card
						sx={{
							borderRadius: 3,
							boxShadow: 4,
							mt: 4,
							p: 2,
							background: "#fffefb",
							marginBottom: 25,
						}}>
						<Box sx={{ textAlign: "center" }}>
							{!userData.signatureID ? (
								<>
									<video
										src='https://allconsulting.s3.eu-north-1.amazonaws.com/pen_animation.webm'
										autoPlay
										loop
										muted
										playsInline
										style={{
											width: "100%",
											maxWidth: 150,
											borderRadius: 12,
											margin: "0 auto 20px",
											display: "block",
										}}
									/>
									<Typography
										variant='h6'
										sx={{
											fontWeight: 600,
											mb: 1,
										}}>
										Semnătura ta, digitalizată
									</Typography>
									<Typography
										sx={{
											fontSize: "14px",
											color: "#555",
											mb: 2,
										}}>
										Încărcati o poză cu semnătura dumneavoastră scrisă pe o{" "}
										<b>foaie albă</b>, astfel procesul de semnare al documentelor va avea
										loc in mod automat.
										<br />
										<br />
										Veți fii notificat întotdeauna când un document a fost întocmit și îl
										veți putea vizualiza din pagina dosarului.
										<br />
										<br />
										Semnarea documentelor nu a fost niciodată mai simplă !
									</Typography>

									<label htmlFor='signature-upload'>
										<Input
											accept='image/*'
											id='signature-upload'
											type='file'
											onChange={handleSignatureUpload}
											sx={{ display: "none" }}
										/>
										<Button
											variant='contained'
											component='span'
											color='warning'
											disabled={isUploading}>
											{isUploading ? (
												<>
													<CircularProgress
														size={20}
														color='inherit'
														style={{
															marginRight: 8,
														}}
													/>
													Procesare...
												</>
											) : (
												<>
													<i
														className='ri-upload-cloud-line'
														style={{
															marginRight: 8,
														}}></i>
													Încarcă semnătura
												</>
											)}
										</Button>
									</label>
								</>
							) : (
								<>
									<style jsx>
										{`
											#send-group {
												animation: 0.32s ease-in-out 1.03s send-group;
												transform-origin: center;
											}

											#send-group #send-path {
												animation: 0.4s cubic-bezier(0.65, 0, 1, 1) 0.8s forwards
													send-path;
												stroke-dasharray: 100;
												stroke-dashoffset: 100;
												stroke-linecap: round;
												stroke-linejoin: round;
											}

											#send-group #outline {
												animation: 0.38s ease-in outline;
												transform: rotate(0deg);
												transform-origin: center;
											}

											#send-group #white-circle {
												animation: 0.35s ease-in 0.35s forwards circle;
												transform: none;
												transform-origin: center;
											}

											@keyframes outline {
												from {
													stroke-dasharray: 0, 345.576px;
												}
												to {
													stroke-dasharray: 345.576px, 345.576px;
												}
											}
											@keyframes circle {
												from {
													transform: scale(1);
												}
												to {
													transform: scale(0);
												}
											}
											@keyframes send-path {
												to {
													stroke-dashoffset: 0;
												}
											}
											@keyframes send-group {
												from {
													transform: scale(1);
												}
												50% {
													transform: scale(1.09);
												}
												to {
													transform: scale(1);
												}
											}
										`}
									</style>
									<Typography
										sx={{
											fontSize: "14px",
											color: "#555",
											mb: 2,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "center",
											textAlign: "center",
										}}>
										<svg
											id='Layer_1'
											xmlns='http://www.w3.org/2000/svg'
											version='1.1'
											viewBox='-55 0 230 110'>
											<path
												fill='#07b481'
												d='M57.5,7.19C29.76,7.19,7.19,29.76,7.19,57.5s22.57,50.31,50.31,50.31,50.31-22.57,50.31-50.31S85.24,7.19,57.5,7.19Z'
											/>
											<path
												fill='#fff'
												d='M92.42,26.79c.02-.12.02-.24,0-.36v-.05c-.03-.14-.08-.27-.15-.39,0-.01,0-.03-.02-.04-.01-.02-.03-.03-.05-.05-.03-.04-.05-.09-.09-.12-.04-.05-.1-.08-.14-.12-.03-.02-.05-.05-.08-.06-.11-.08-.24-.14-.37-.18-.02,0-.05,0-.07-.01-.11-.03-.23-.03-.34-.03-.04,0-.08,0-.11.01h-.1L17.56,41.79c-.52.12-.9.54-.98,1.06-.07.52.19,1.04.65,1.29l19.83,10.67,6.18,19.69.03.06c.02.05.04.09.07.13.05.1.11.18.18.26.02.02.03.05.05.07s.04.02.06.04c.08.07.17.13.27.18.04.02.07.04.11.06.14.05.28.08.44.08h.03c.15,0,.29-.04.43-.09.03-.01.06-.04.1-.05.11-.05.21-.12.29-.2.02-.02.04-.02.05-.04l10.12-10.29,19.54,10.52c.19.1.39.15.6.15.16,0,.32-.03.47-.09.35-.14.62-.42.73-.78l15.56-47.5s.01-.08.02-.11c0-.04.02-.08.02-.12h.01ZM81.84,30.01l-43.71,22.51-16.71-8.99,60.42-13.51h0ZM79.22,34.21l-31.62,24.25h0c-.09.07-.18.16-.25.26-.02.02-.03.04-.04.06,0,.02-.03.04-.05.07-.05.08-.08.17-.1.26h0s-2.8,10.47-2.8,10.47l-4.71-15.01,39.58-20.38v.02ZM46.91,69.83l2.27-8.49,3.98,2.14-6.25,6.35ZM74.88,72.3l-24.19-13.02,38.01-29.16-13.82,42.18ZM27.44,93.63c-.32,0-.64-.12-.89-.36-.5-.49-.5-1.29-.02-1.79l12.05-12.25c.49-.5,1.29-.5,1.79-.02.5.49.5,1.29.02,1.79l-12.05,12.25c-.25.25-.57.38-.9.38ZM47.28,88.66c-.32,0-.64-.12-.89-.36-.5-.49-.5-1.29-.02-1.79l12.05-12.25c.49-.5,1.29-.5,1.79-.02.5.49.5,1.29.02,1.79l-12.05,12.25c-.25.25-.57.38-.9.38ZM23.68,78.24c-.32,0-.64-.12-.89-.36-.5-.49-.5-1.29-.02-1.79l8.81-8.95c.49-.5,1.29-.5,1.79-.02.5.49.5,1.29.02,1.79l-8.8,8.95c-.25.25-.57.38-.9.38h-.01Z'
											/>
										</svg>
										<br />
										Semnătură dumneavoastră a fost incarcată cu succes. Veți fii notificat
										de fiecare data când un document este întocmit și semnat.
										<br />
										<br />
										<Button
											variant='outlined'
											component='span'
											size='large'
											onClick={() => handleViewSignature(userData.signatureID)}>
											<i
												className='ri-eye-line'
												style={{
													marginRight: 5,
												}}></i>
											Vizualizare semnatura
										</Button>
									</Typography>
								</>
							)}

							<NotificationSheet
								open={isOpen}
								onClose={() => setIsOpen(false)}
								type='success'
								title={notificationTitle}
								message={notificationMessage}
								confirmText='Închide'
								withCancel={false}
								onConfirm={() => setIsOpen(false)}
								imageUrl={openDoc}
							/>

							<DeleteAccountSheet
								open={isOpenDelete}
								onClose={() => setIsOpenDelete(false)}
								onConfirm={() => handleDeleteAccount()}
								loading={false}
							/>

							<ChangePasswordSheet
								open={isOpenPassword}
								onClose={() => setIsOpenPassword(false)}
								onSave={() => setIsOpenPassword(false)}
								loading={false}
							/>

							<ChangeEmailSheet
								open={isOpenEmail}
								onClose={() => setIsOpenEmail(false)}
								onSave={() => setIsOpenEmail(false)}
								loading={false}
								email={userData.email}
							/>

							<ChangePersonalDetailsSheet
								open={isOpenDetails}
								onClose={() => setIsOpenDetails(false)}
								loading={false}
								details={{
									firstName: userData.firstName,
									lastName: userData.lastName,
									phoneNumber: userData.phoneNumber,
									cnp: userData.cnp,
									mailingStreet: userData.mailingStreet,
								}}
							/>

							<ChangeSettingsSheet
								open={isOpenSettings}
								onClose={() => setIsOpenSettings(false)}
								loading={false}
							/>
						</Box>
					</Card>
				</Box>
			</>
		);
	}
}
